import { render, staticRenderFns } from "./pricetest.vue?vue&type=template&id=29c0477b&scoped=true"
import script from "./pricetest.vue?vue&type=script&lang=js"
export * from "./pricetest.vue?vue&type=script&lang=js"
import style0 from "./pricetest.vue?vue&type=style&index=0&id=29c0477b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c0477b",
  null
  
)

export default component.exports